var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDepositFunds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3598.32 3598.32",
    id: "svg43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs37"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "depositFundsGradient",
    gradientUnits: "userSpaceOnUse",
    x1: 1799.16,
    y1: 35.26,
    x2: 1799.16,
    y2: 3563.05
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#D9E021"
    },
    id: "stop30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541176,
    style: {
      stopOpacity: 1,
      stopColor: "#0D9743"
    },
    id: "stop32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#009245"
    },
    id: "stop34"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#depositFundsGradient)"
    },
    d: "M35.27 1799.16c0,974.17 789.72,1763.89 1763.89,1763.89 974.17,0 1763.89,-789.72 1763.89,-1763.89 0,-974.17 -789.72,-1763.89 -1763.89,-1763.89 -974.17,0 -1763.89,789.72 -1763.89,1763.89zm1554.05 -1015.58l419.67 0 0 805.74 805.75 0 0 419.67 -805.75 0 0 805.76 -419.67 0 0 -805.76 -805.75 0 0 -419.67 805.75 0 0 -805.74z",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cross",
    style: {
      strokeWidth: 0.999999,
      fillRule: "evenodd",
      fill: "currentColor"
    },
    d: "M 60.068359 29.615234 L 60.068359 60.068359 L 29.615234 60.068359 L 29.615234 75.929688 L 60.068359 75.929688 L 60.068359 106.38477 L 75.929688 106.38477 L 75.929688 75.929688 L 106.38477 75.929688 L 106.38477 60.068359 L 75.929688 60.068359 L 75.929688 29.615234 L 60.068359 29.615234 z ",
    transform: "scale(26.458333)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDepositFunds);
export default __webpack_public_path__ + "static/media/icon-deposit-funds.18df69f7298f594b7b16c8f5dc4e8689.svg";
export { ForwardRef as ReactComponent };